module.exports = __webpack_public_path__ + "img/icon_yz.7c196d16.png";